module.exports = __webpack_public_path__ + "img/frame.452cf24a.png";